import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState("popularity");

  useEffect(() => {
    axios
      .get("https://hrgf.salepatner.com/api/categories/")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* 🔝 Navbar */}
      <Header />

      {/* 🧭 Breadcrumb */}
      <div className="max-w-7xl mx-auto px-6 pt-6 text-sm text-gray-500">
        <span className="hover:text-gray-700 cursor-pointer">Home</span>
        <span className="mx-1">/</span>
        <span className="font-semibold text-gray-800">Categories</span>
      </div>

      {/* 🏷️ Page Title + Dropdown */}
      <div className="max-w-7xl mx-auto px-6 py-6 flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Categories</h1>

        <select className="border border-gray-300 text-gray-800 text-sm rounded-md px-4 py-2 bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-600">
          <option>Home Categories</option>
          <option>Biggest Sales</option>
          <option>Electronics</option>
          <option>Fashion</option>
          <option>Home & Kitchen</option>
          <option>Min 50% Cashback</option>
          <option>Credit Cards</option>
          <option>Mobiles</option>
          <option>Flights & Hotels</option>
          <option>Food & Grocery</option>
        </select>
      </div>

      {/* 🔹 Tabs */}
      <div className="max-w-7xl mx-auto px-6 mb-10">
        <div className="flex border border-gray-200 rounded-lg overflow-hidden bg-white">
          {["Top Picks","Browse All", "Cashback %", "High Rewards", "Latest Deals"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab.toLowerCase())}
              className={`flex-1 py-3 text-sm font-semibold border-r border-gray-200 last:border-none transition-colors ${
                activeTab === tab.toLowerCase()
                  ? "text-blue-700 border-b-2 border-blue-700 bg-white"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* 🛍️ Category Cards */}
      <div className="max-w-7xl mx-auto px-6 pb-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {categories.length > 0 ? (
            categories.map((cat, i) => (
              <div
                key={cat.id || i}
                className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all"
              >
                {/* Offer Banner */}
                <div className="bg-pink-50 text-pink-600 text-xs font-semibold text-center py-2 rounded-t-xl">
                  {cat.offer_text || "Upto 70% Off"}
                </div>

                {/* Logo */}
                <div className="flex items-center justify-center py-6">
                  <img
                    src={cat.icon}
                    alt={cat.name}
                    className="w-24 h-12 object-contain"
                  />
                </div>

                {/* Cashback Footer */}
                <div className="text-center py-3 bg-blue-700 text-white text-sm font-semibold rounded-b-xl">
                  {cat.cashback_text || "Upto 5% Cashback"}
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center col-span-full py-10">
              Loading categories...
            </p>
          )}
        </div>
      </div>

      {/* 🔻 Footer */}
      <Footer />
    </div>
  );
};

export default Categories;
